<template>
  <div style="height:100%;width:100%;padding: 1em;">
    <div style="width: 100%;height: 90vh;overflow: scroll;padding: 0 0.5em;overflow-x: hidden;" id="prescriptions-modal">
      <div>
        <div style="width: 100;height: 85vh;overflow: scroll;" class="selected-reminders-prescription">
          <prescription :prescription="
                              selectedPrescription.prescriptions[0]
                                .prescriptions
                            " v-if="
                              selectedPrescription.prescriptions[0]
                                .prescriptions
                            " :appointment="selectedPrescription" :editable="false"></prescription>
        </div>
        <div class="col-12" style="padding: 0px;text-align:center">
          <n-button type="primary" round size="sm" @click.native="addReminders()">
            {{ $t("message.Add") }}
          </n-button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  async mounted() {
    await this.$store.commit("setState", {
      stateName: "appointment",
      stateValue: this.selectedPrescription,
    });
  },
  methods: {
    addReminders() {
      swal
        .fire({
          title: this.$t("message.Are you sure that you want to add medication reminders from this prescription?"),
          confirmButtonText: this.$t("message.Yes"),
          showCancelButton: true,
          cancelButtonText: this.$t("message.No"),
        })
        .then(async (result) => {
          if (result && result.value) {
            this.$router.push("setreminders");
          }
        });
    },
  },
  computed: {
    selectedPrescription() {
      return this.$store.state.selectedPrescription;
    },
  },
};
</script>
